import { Plugin,  FileDialogButtonView, FileRepository, logError } from 'ckeditor5';


export default class AudioUI extends Plugin {

    static get pluginName() {
		return 'AudioUI';
	}

	static get requires() {
		return [ FileRepository ];
	}

    init() {
        // console.log('AudioUI#init');

		const editor = this.editor;
		const t = editor.t;
		// const model = editor.model;

		// Add the "simpleAudioButton" to feature components.
		editor.ui.componentFactory.add( 'simpleAudio', locale => {
			const view = new FileDialogButtonView( locale );

			view.set( {
				acceptedType: 'audio/mpeg',
				allowMultipleFiles: false,
				icon : '<svg width="32px" height="32px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><title>file_type_audio</title><path d="M17.229,4a.9.9,0,0,0-.569.232l-7.6,6.32a1.158,1.158,0,0,1-.955.328H3.208A1.2,1.2,0,0,0,2,12.088v7.826A1.2,1.2,0,0,0,3.208,21.12H8.1a1.158,1.158,0,0,1,.955.328l7.6,6.32c.521.433,1.081.224,1.081-.289V4.522A.494.494,0,0,0,17.229,4ZM27,6.3,25.209,8.093a14.708,14.708,0,0,1,0,15.844l1.785,1.776A17.19,17.19,0,0,0,27,6.3Zm-4.333,4.323L20.905,12.4a6.035,6.035,0,0,1,0,7.237l1.756,1.756a8.554,8.554,0,0,0,.01-10.769Z" style="fill:#00007f"/></svg>',
				
				label: t( 'Simple audio' ),
                withText: false,
				tooltip: true
			} );

			view.on( 'done', ( evt, files ) => {
				if ( files[ 0 ] ) {
					this.insertAudio( files[ 0 ] );
				} else {
					logError( 'No file available', {} );
				}
			} );

			return view;
		} );

    }

    insertAudio( file ) {
		const editor = this.editor;
		// console.log( 'insert audio from file ', file );
		// console.log( 'plugins', editor.plugins );
		const fileRepository = editor.plugins.get( 'FileRepository' );
		const loader = fileRepository.createLoader( file );
        // console.log('Created loader', loader);
		loader.upload().then( result => this.createAudio( result ), error => console.log( 'error', error ) );
		// console.log( 'Repository', fileRepository );
	}

	createAudio( uploadResult ) {
		const model = this.editor.model;

		// console.log( 'uploadResult', uploadResult );
		model.change( writer => {
			const audio = writer.createElement( 'simpleaudio', { source: uploadResult.url, controls: '' } );

			// Locally this delay was not necessary, but on Cyon it solved the problem, that audios run only after a reload
			// The delay of 1 sec is emirical, but 0.5 sec was not sufficient
			// Probably it would be better to probe if the mp3 file is available
			// loader.upload is a promise and we get to createAudio only after php stored the file,
			// but apparently it is not yet available as soon as it has been successfully stored
			setTimeout( () => model.insertContent( audio ), 1000);
		} );
	}
}